module.exports = __webpack_public_path__ + "static/media/programmer.d86d0a61.svg";